import * as React from 'react';
import { connect } from 'react-redux';
import { Component } from 'react';
import {
    Container,
    Row,
    Col,
    Button
} from 'reactstrap';
import './Home.css';
import HomeCarousel from './HomeCarousel';
import HomeLogoCarousel from './HomeLogoCarousel';

const items = Array(
    {
        src: '../img/premierco_homepage_spring_01.jpg',
        url: '/contact-us'
    },
    {
        src: '../img/premierco_hoempage_commerical_02.jpg',
        url: '/services/commerical-building'
    },
    {
        src: '../img/premierco_homepage_patio_03.jpg',
        url: '/services/residential-patio'
    },
    {
        src: '../img/premierco_homepage_03.jpg',
        url: '/services/commerical-building'
    }
);

const Home = () => (
    <div className="home">
        <HomeCarousel items={items} />
        <Container fluid>
            <Row className="bulletin">
                <Col sm="12" md={{ size: 10, offset: 1 }}>
                    <h2>Residential and Commerical Pressure Washing and Window Cleaning in the Metro Phoenix Area</h2>
                    <h5>We offer a 100% satisfaction guaranteed on every pressure wash. If you aren&apos;t happy with the results neither are we. Get started with a free price quote by calling us at (602) 689-6045 or email us at info@premierpressurewash.com.</h5>
                </Col>
            </Row>
            <Row>
                <Col md="4" sm="12" className="panel">
                    <img alt="Window Cleaning" src="../img/premierco-homepage-windows.jpg"></img>
                    <h5>Window Washing</h5>
                    <p className="services">First impressions truly matter when it comes to owning a home or business. When people are visiting your property, the last thing you want are your guests associating you with dirty, streaky windows that leave a lasting impression.</p>
                    <Button color="primary" href="/services/residential-windows">Learn More</Button>
                </Col>
                <Col md="4" sm="12" className="panel">
                    <img alt="Driveway Cleaning" src="../img/premierco-homepage-driveway.jpg"></img>
                    <h5>Driveway Cleaning</h5>
                    <p className="services">An unsightly driveway can make your home&apos;s front entrance unappealing! We pressure wash the oils, stains, & tire marks from your concrete or paver driveway to have it looking new again.</p>
                    <Button color="primary" href="/services/residential-driveway">Learn More</Button>
                </Col>
                <Col md="4" sm="12" className="panel">
                    <img alt="House Washing" src="../img/premierco-homepage-home.jpg"></img>
                    <h5>House Washing</h5>
                    <p className="services">When&apos;s the last time you gave your house a wash? You wash your car every week but neglect your most expensive asset! Your house! We use low-pressure soft washing techniques & eco-friendly cleaning agents to wash the dirt and debris from the exterior of your home.</p>
                    <Button color="primary" href="/services/residential-house-washing">Learn More</Button>
                </Col>
            </Row>
            <Row className="bulletin free-estimate">
                <Col sm="12" md={{ size: 10, offset: 1 }}>
                    <h4 className="quotes">FREE QUOTES</h4>
                    <h2>Call Premier Pressure Washing and Window Cleaning For A FREE Estimate!
                        <br></br><a href="tel:16026896045">(602) 689-6045</a></h2>
                    <p>Premier Pressure specializes in professional pressure washing services for both residential and commercial customers in Arizona. Sign up for our Monthly service plan and keep your home or business clean all year long!</p>
                </Col>
            </Row>
            <Row>
                <Col className="video-container"><iframe width="560" height="315" src="https://www.youtube.com/embed/2-e-_geUtdI" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe></Col>
            </Row>
            <Row>
                <Col md="6" sm="12" className="panel why-premier-background" style={{
                    backgroundImage: 'url("../img/premierco_windows_cleaning.jpg")'
                }}></Col>
                <Col md="6" sm="12" className="panel guarantees">
                    <h2>WHY CHOOSE PREMIER PRESSURE WASHING AND WINDOWS CLEANING</h2>
                    <p>When searching for a contractor to wash your property, realize that not all pressure washing contractors are the same. Price should not be the first consideration when choosing. After all your property is your largest investment and it should be well protected.</p>
                    <p>Questions that you should ask when looking for the &quot;right&quot; washing contractor:</p>
                    <ul>
                        <li>Is your company Insured?</li>
                        <li>What cleaning methods do you use?</li>
                        <li>What type of detergents will you be using?</li>
                        <li>Do you have a list of references?</li>
                        <li>Do you guarantee your work?</li>
                    </ul>
                    <p>By selecting Premier Pressure Washing &amp; Window Cleaning, you can skip the guess work and have confidence you have selected the best contractor for your pressure washing job. Below are just some of the highlights that sets us apart from other competitions:</p>
                    <ul>
                        <li>Insured and Fully Licensed</li>
                        <li>Environmental Protection Agency (EPA) and Local Regulatory Compliant</li>
                        <li>Professional Pressure Washing Equipment</li>
                        <li>Available Full Reclaim and Recovery System</li>
                    </ul>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h2 className="trusted-shoutout">TRUSTED BY COMPANIES IN THE GREATER PHOENIX AREA</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <HomeLogoCarousel />
                </Col>
            </Row>
            <Row>
                <Col></Col>
            </Row>
        </Container>
    </div>
);

export default connect()(Home);
